"use strict";
var createVAO = require('gl-vao');
var createBuffer = require('gl-buffer');
var square = new Float32Array([
    -1.0, -1.0,
    1.0, -1.0,
    -1.0, 1.0,
    -1.0, 1.0,
    1.0, -1.0,
    1.0, 1.0,
]);
var SpriteManager = (function () {
    function SpriteManager(gl, stitcher) {
        this.gl = gl;
        this.stitcher = stitcher;
        this.registry = {};
    }
    SpriteManager.prototype.register = function (id, shape, textures, scale) {
        if (scale === void 0) { scale = 1; }
        var length = shape[0] * shape[1];
        var uvs = new Float32Array(length * 12);
        var positions = new Float32Array(length * 12);
        for (var i = 0; i < length; ++i) {
            var texture = textures[i];
            var uv = this.stitcher.getTextureUV(texture);
            if (!uv)
                return null;
            var idx = 12 * i;
            uvs[idx + 0] = uv[2 * 3 + 0];
            uvs[idx + 1] = uv[2 * 3 + 1];
            uvs[idx + 2] = uv[2 * 2 + 0];
            uvs[idx + 3] = uv[2 * 2 + 1];
            uvs[idx + 4] = uv[2 * 0 + 0];
            uvs[idx + 5] = uv[2 * 0 + 1];
            uvs[idx + 6] = uv[2 * 0 + 0];
            uvs[idx + 7] = uv[2 * 0 + 1];
            uvs[idx + 8] = uv[2 * 2 + 0];
            uvs[idx + 9] = uv[2 * 2 + 1];
            uvs[idx + 10] = uv[2 * 1 + 0];
            uvs[idx + 11] = uv[2 * 1 + 1];
        }
        var centerX = shape[0] - 1;
        var centerY = shape[1] - 1;
        for (var i = 0; i < shape[0]; ++i) {
            var offsetX = 2 * i - centerX;
            for (var j = 0; j < shape[1]; ++j) {
                var offsetY = 2 * j - centerY;
                var idx = 12 * (i * shape[1] + j);
                for (var k = 0; k < 6; ++k) {
                    positions[idx + 2 * k + 0] = (square[2 * k + 0] + offsetX) * scale;
                    positions[idx + 2 * k + 1] = (square[2 * k + 1] + offsetY) * scale;
                }
            }
        }
        var vao = createVAO(this.gl, [{
                buffer: createBuffer(this.gl, positions),
                size: 2,
            }, {
                buffer: createBuffer(this.gl, uvs),
                size: 2,
            }]);
        vao.length = positions.length / 2;
        return this.registry[id] = vao;
    };
    SpriteManager.prototype.get = function (id) {
        return this.registry[id];
    };
    return SpriteManager;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SpriteManager;
//# sourceMappingURL=SpriteManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/SpriteManager.js
 ** module id = 917
 ** module chunks = 0
 **/